import React from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "spark-core-dx/components";

const ExecutionControlDomain = () => (
  <Layout layoutOverride="standard">
    <Outlet />
  </Layout>
);

export default ExecutionControlDomain;
